<div [ngClass]="isMenuDisabled ? 'sidemenu-disabled' : null"></div>
<div
  class="sidemenu-header"
  [ngStyle]="{
    'background-color': navbarSettings && navbarSettings.headerImageBackgroundColor ? navbarSettings.headerImageBackgroundColor : '',
  }"
>
  @if (isAuthenticated || isTenantAdminAuthenticated) {
    <button
      type="button"
      (click)="toggleSideMenu()"
      class="menu-toggle"
      attr.aria-label="{{ 'accessibility_alt_collapse_menu_icon' | translate }}"
    >
      <i class="fas fa-bars" [ngClass]="isMenuHeaderColorLight ? 'primary-color' : ''"></i>
    </button>
  }
  @if (sideMenuService.sidemenuExpanded && navbarSettings && navbarSettings.headerImage) {
    <img class="logo" [src]="transform(navbarSettings.headerImage)" [alt]="'accessibility_alt_brand_logo_img' | translate" />
  }
</div>
<div class="sidemenu-container">
  @for (sidemenu of sidemenuItems; track sidemenu) {
    @if (sidemenu.sidemenuLink == null) {
      <a class="spacer simple-menu-item" [ngClass]="[isMenuDisabled ? 'disabled' : '']">
        <div class="icon-column">
          @if (sidemenu.sidemenuIcon) {
            <i class="menu-item-icon fas" [ngClass]="sidemenu.sidemenuIcon"></i>
          }
        </div>
        @if (sideMenuService.sidemenuExpanded) {
          <div class="title-column">
            <span class="menu-item-title">{{ sidemenu.sidemenuName | translate }}</span>
          </div>
        }
      </a>
    }
    @if (sidemenu.sidemenuLink != null) {
      <a
        class="simple-menu-item"
        [ngClass]="[isMenuDisabled ? 'disabled' : '']"
        [routerLink]="isMenuDisabled ? null : sidemenu.sidemenuLink"
        [routerLinkActive]="isMenuDisabled ? '' : 'active'"
        (click)="resetServerErrorFlag()"
        (middleclick)="isMenuDisabled ? null : openNewTab(sidemenu.sidemenuLink)"
      >
        <div class="icon-column">
          @if (sidemenu.sidemenuIcon) {
            <i class="menu-item-icon fas" [ngClass]="sidemenu.sidemenuIcon"></i>
          }
        </div>
        @if (sideMenuService.sidemenuExpanded) {
          <div class="title-column">
            <span class="menu-item-title">{{ sidemenu.sidemenuName | translate }}</span>
          </div>
        }
      </a>
    }
  }
  @if (feedbackEmail) {
    <a
      class="simple-menu-item feedback-menu-item"
      [ngClass]="[sideMenuService.sidemenuExpanded ? 'expanded' : '']"
      href="mailto:{{ feedbackEmail }}?subject=Feedback FinOffice"
    >
      <div class="icon-column">
        <i class="menu-item-icon fas fa-comments"></i>
      </div>
      @if (sideMenuService.sidemenuExpanded) {
        <div class="title-column">
          <span class="menu-item-title">{{ 'sidemenu_feedback' | translate }}</span>
        </div>
      }
    </a>
  }
  @if (sideMenuService.sidemenuExpanded) {
    <mat-divider></mat-divider>
  }
  @if (sideMenuService.sidemenuExpanded && quoteText && quoteAuthor) {
    <div class="sidemenu-quote-container">
      <span class="quote">"{{ quoteText }}"</span>
      <span class="author">{{ quoteAuthor }}</span>
    </div>
  }
</div>
<a (click)="openExternalLink('http://finoffice.com/')" class="footer">
  <span class="menu-item-title">{{ sideMenuService.sidemenuExpanded ? environtment.poweredByFull : environtment.poweredByReduced }}</span>
</a>
